import auth from '../auth';
import ApigClientFactory from '../apigClient';

export const DataOverrideService = {
    async query(body) {
        let config = {
            invokeUrl: process.env.PA_ADMIN_API_URL,
            region: process.env.AWS_REGION,
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };

        await auth.getCredentialsForRole(process.env.PA_ROLE_DATA_ADMIN)
            .then((credentials) => {
                config.accessKey = credentials.Credentials.AccessKeyId;
                config.secretKey = credentials.Credentials.SecretKey;
                config.sessionToken = credentials.Credentials.SessionToken;
            });

        let client = ApigClientFactory.newClient(config);

        return client.invokeApi({}, '/pa-dataoverride', 'POST', {}, body);
    },
    async get() {
        let config = {
            invokeUrl: process.env.PA_ADMIN_API_URL,
            region: process.env.AWS_REGION,
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };
        await auth.getCredentialsForRole(process.env.PA_ROLE_DATA_ADMIN)
            .then((credentials) => {
                config.accessKey = credentials.Credentials.AccessKeyId;
                config.secretKey = credentials.Credentials.SecretKey;
                config.sessionToken = credentials.Credentials.SessionToken;
            });

        let client = ApigClientFactory.newClient(config);
        return client.invokeApi({}, '/pa-dataoverride', 'GET', {});
    }
};



// WEBPACK FOOTER //
// ./src/services/pa/dataoverride.service.js